module.exports = __webpack_public_path__ + "img/overlay.513e962d.png";